import {
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  Spinner,
  Text,
} from '@chakra-ui/react'
import { ISharedDiagnostic } from '../../../../../types/diagnostics'
import { useGetInvoiceFr } from '../../../../../api/api_hooks/invoices'
import { PDFDownloadLink } from '@react-pdf/renderer'
import Invoice from '../../../../Invoice'
import { DownloadIcon } from '@chakra-ui/icons'
import { useTranslation } from 'react-i18next'

const InvoiceInfo = ({
  diagnosticData,
}: {
  diagnosticData: ISharedDiagnostic
}) => {
  const { result: invoiceData } = useGetInvoiceFr(diagnosticData.id)
  const { t } = useTranslation()

  return (
    <Flex direction={'column'} h={'100%'}>
      <Divider my={3} />
      <Box my={4} mx={2} h={'100%'}>
        <Heading fontFamily={'Poppins'} as={'p'} size="sm">
          {t('sharedDiagnostic.invoice.titleInfo')}
        </Heading>
        {invoiceData && (
          <Box mt={4}>
            <Text color={'brand.lightGrayText'}>
              {t('shared.common.shortNumber')} {invoiceData.invoiceNumber}
            </Text>
            <PDFDownloadLink
              document={<Invoice invoiceData={invoiceData} />}
              fileName={`${invoiceData.invoiceNumber}.pdf`}
            >
              {({ loading }) => (
                <Button colorScheme="gray" my={2} size={'sm'}>
                  {loading ? (
                    <Spinner size={'xs'} mr={4} />
                  ) : (
                    <DownloadIcon mr={4} />
                  )}
                  <span>
                    {loading
                      ? `${t('shared.common.loading')}`
                      : `${t('sharedDiagnostic.invoice.dowloadInvoice')}`}
                  </span>
                </Button>
              )}
            </PDFDownloadLink>
          </Box>
        )}
      </Box>
    </Flex>
  )
}

export default InvoiceInfo
